import { Suspense } from 'react';

export default function LazyLoading({ children }) {
  return <Suspense fallback={<></>}>{children}</Suspense>;
}
